import AggregateChoicePrompt from './aggregate-choice-prompt.vue';
import CheckboxListPrompt from './checkbox-list-prompt.vue';
import DatePickerPrompt from './date-picker-prompt.vue';
import FoodSelectionPrompt from './food-selection-prompt.vue';
import InfoPrompt from './info-prompt.vue';
import NoMoreInformationPrompt from './no-more-information-prompt.vue';
import RadioListPrompt from './radio-list-prompt.vue';
import SelectPrompt from './select-prompt.vue';
import SliderPrompt from './slider-prompt.vue';
import TextareaPrompt from './textarea-prompt.vue';
import TimePickerPrompt from './time-picker-prompt.vue';
import YesNoPrompt from './yes-no-prompt.vue';

export default {
  AggregateChoicePrompt,
  CheckboxListPrompt,
  DatePickerPrompt,
  FoodSelectionPrompt,
  InfoPrompt,
  NoMoreInformationPrompt,
  RadioListPrompt,
  SelectPrompt,
  SliderPrompt,
  TimePickerPrompt,
  TextareaPrompt,
  YesNoPrompt,
};
